/**
 * Sticky CTA v2 (Flock Armor A/B v2): syncs pill label and combined CTA price with variant + selling plan state.
 * Relies on existing PDP scripts updating .sticky-cta-price spans; observes DOM and listens for Skio events.
 */
(function () {
  var BODY_CLASS = "product-a-b-test-flock-armor-v2";

  function isTargetTemplate() {
    return document.body.classList.contains(BODY_CLASS);
  }

  function getRoot() {
    return document.querySelector(".sticky-cta-v2");
  }

  function sellingPlanActive() {
    var input = document.querySelector('input[name="selling_plan"]');
    return !!(input && input.value);
  }

  function syncPillLabel() {
    if (!isTargetTemplate()) return;
    var root = getRoot();
    var el = root && root.querySelector("[data-sticky-v2-pill-label]");
    if (!el || !root) return;
    var sub = root.getAttribute("data-label-subscription") || "Subscription &";
    var ot = root.getAttribute("data-label-onetime") || "One-time";
    el.textContent = sellingPlanActive() ? sub : ot;
  }

  function readPriceFromVariantInputs() {
    var input =
      document.querySelector(".main-product-section variant-selects input[data-total-price]:checked") ||
      document.querySelector("variant-selects input[data-total-price]:checked");
    if (!input) return null;
    if (sellingPlanActive()) {
      return input.getAttribute("data-total-price-sub") || input.getAttribute("data-total-price");
    }
    return input.getAttribute("data-total-price");
  }

  function syncCtaPrice() {
    if (!isTargetTemplate()) return;
    var root = getRoot();
    var out = root && root.querySelector("[data-sticky-v2-cta-price]");
    if (!out || !root) return;

    var subEl = root.querySelector("[data-subscription-price]");
    var oneEl = root.querySelector("[data-one-time-price]");
    var fromSpans = sellingPlanActive()
      ? subEl && subEl.textContent.trim()
      : oneEl && oneEl.textContent.trim();

    if (fromSpans) {
      out.textContent = fromSpans;
      return;
    }

    var fromVariant = readPriceFromVariantInputs();
    if (fromVariant) out.textContent = fromVariant;
  }

  function syncAll() {
    syncPillLabel();
    syncCtaPrice();
  }

  function getSkioPlanPicker() {
    return (
      document.querySelector(".main-product-section skio-plan-picker") ||
      document.querySelector("skio-plan-picker")
    );
  }

  function focusSkioFrequencyDropdown(skio) {
    if (!skio || !skio.renderRoot || typeof skio.renderRoot.querySelector !== "function") return;
    var dd = skio.renderRoot.querySelector(".selling-plan-dropdown");
    if (!dd || !dd.options || dd.options.length < 1) return;
    try {
      dd.focus({ preventScroll: true });
      if (typeof dd.showPicker === "function") {
        dd.showPicker();
      }
    } catch (e) {
      /* showPicker not supported or blocked */
    }
  }

  function activateSkioSubscriptionFromPill() {
    var skio = getSkioPlanPicker();
    if (!skio) return;

    skio.scrollIntoView({ behavior: "smooth", block: "center" });

    function selectSubscriptionGroupIfNeeded() {
      if (sellingPlanActive()) return;
      var groups = skio.availableSellingPlanGroups;
      var first = groups && groups[0];
      if (!first || typeof skio.selectSellingPlanGroup !== "function") return;
      skio.selectSellingPlanGroup(first);
    }

    function tryFocusDropdown() {
      focusSkioFrequencyDropdown(skio);
    }

    function runWhenSkioReady() {
      if (!skio.availableSellingPlanGroups || !skio.availableSellingPlanGroups.length) {
        return false;
      }
      selectSubscriptionGroupIfNeeded();
      requestAnimationFrame(tryFocusDropdown);
      setTimeout(tryFocusDropdown, 120);
      setTimeout(tryFocusDropdown, 450);
      return true;
    }

    if (!runWhenSkioReady()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (runWhenSkioReady() || attempts > 35) {
          clearInterval(timer);
        }
      }, 100);
    }
  }

  function bindSubscriptionPill(root) {
    var pill = root.querySelector("[data-sticky-v2-subscription-trigger]");
    if (!pill) return;

    pill.addEventListener("click", function (e) {
      e.preventDefault();
      activateSkioSubscriptionFromPill();
    });

    pill.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activateSkioSubscriptionFromPill();
      }
    });
  }

  function bindObserver() {
    var root = getRoot();
    if (!root || typeof MutationObserver === "undefined") return;

    var priceWrap = root.querySelector(".sticky-cta-price-item");
    if (!priceWrap) return;

    var obs = new MutationObserver(function () {
      syncCtaPrice();
    });
    obs.observe(priceWrap, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    if (!isTargetTemplate()) return;
    if (!getRoot()) return;

    syncAll();
    bindObserver();
    bindSubscriptionPill(getRoot());

    document.addEventListener("skio::update-selling-plan", function () {
      requestAnimationFrame(syncAll);
      setTimeout(syncAll, 350);
      setTimeout(syncAll, 1100);
    });

    document.addEventListener("change", function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest("variant-selects")) {
        requestAnimationFrame(syncAll);
        setTimeout(syncAll, 200);
        setTimeout(syncAll, 1600);
      }
      if (ev.target && ev.target.getAttribute && ev.target.getAttribute("name") === "selling_plan") {
        requestAnimationFrame(syncAll);
        setTimeout(syncAll, 400);
      }
    });

    var planInput = document.querySelector('input[name="selling_plan"]');
    if (planInput) {
      planInput.addEventListener("change", syncAll);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
